import React, { useState, useRef, useEffect } from "react";
import { Button } from "../../../common/commonIndex";

const Height = ({ handleNextEvent, formData, questionData }) => {
    const [feet, setFeet] = useState(formData?.answer?.length > 0 ? formData.answer[0] : 5 || 5);
    const [inches, setInches] = useState(formData?.answer?.length > 0 ? formData?.answer[1] : 6 || 6);

    // Refs for feet and inches spinners
    const feetRefs = useRef([]);
    const inchesRefs = useRef([]);
    useEffect(() => {
        if(formData){
            if (!formData?.answer || !Array.isArray(formData.answer)) {
                formData.answer = [];
            }
            if (!formData?.fkAnswerIds || !Array.isArray(formData.fkAnswerIds)) {
                formData.fkAnswerIds = [];
            }
    
            if (!formData.answer[0]) {
                formData.answer[0] = 5;
                formData.fkAnswerIds[0] = 5;
            }
            if (!formData.answer[1]) {
                formData.answer[1] = 6;
                formData.fkAnswerIds[1] = 6;
            }
        }
        
    }, [])
    // Scroll the selected item into view when feet changes
    useEffect(() => {
        const answer = formData?.answer && formData?.answer?.length > 0
            ? formData?.answer[0]
            : feet;

        if (feetRefs.current[feet - 1]) {
            feetRefs.current[feet - 1].scrollIntoView({
                block: "center",
                behavior: "smooth",
            });
        }
    }, [feet, formData?.answer]);

    // Scroll the selected item into view when inches changes
    useEffect(() => {
        const answer = formData?.answer && formData?.answer?.length > 0
            ? formData?.answer[1]
            : inches;
        if (inchesRefs.current[inches - 1]) {
            inchesRefs.current[inches - 1].scrollIntoView({
                block: "center",
                behavior: "smooth",
            });
        }
    }, [inches, formData?.answer]);

    const handleFeetChange = (value) => {
        setFeet(value);
        if (formData?.answer?.length > 0) {
            formData.answer[0] = value;
            formData.fkAnswerIds[0] = value;
        }
    };

    const handleInchesChange = (value) => {
        setInches(value);
        if (formData?.answer?.length > 0) {
            formData.answer[1] = value;
            formData.fkAnswerIds[1] = value;
        }
    };

    // Handle form submission
    const handleSubmit = (e) => {
        // skip then 2 otherwise 1
        let skip = 1;
        // if(questionData?.skippedNestedQuestionID){
        //     skip = 2;
        // }
        const findData = getLocalStorageData();
        findData[questionData.questionerIndex] = formData;
        setLocalStorageData(findData);
        handleNextEvent(questionData?.questionerIndex + skip);
    };

    const getLocalStorageData = () =>{
        const findlocalStorageData =  JSON.parse(localStorage.getItem('listOfAnswer'));
         return findlocalStorageData;
     }
     const setLocalStorageData = (data) =>{
       if(data?.length > 0){
         localStorage.setItem('listOfAnswer', JSON.stringify(data));
       }
     }

    
    // Helper function to determine the opacity class
    const getOpacityClass = (index, selectedIndex, totalItems) => {
        let isNearSelected = false;
        if (selectedIndex > 5) {
            isNearSelected = Math.abs(index - selectedIndex) <= 1;
        } else {
            isNearSelected = Math.abs(index - selectedIndex) <= 2;
        }

        return isNearSelected ? "opacity-1" : "opacity-0-5";
    };
    return (
        <div>
            <div className="eligibility questionnaire">
                <h3 className="title">{questionData?.question}</h3>
                <div className="height-spinner">
                    <div className="feet position-relative">
                    <div className={'selected-feet'}></div>
                        <div className="spinner-container">
                            {Array.from({ length: 10 }, (_, index) => index + 1).map((value) => (
                                // ${getOpacityClass(
                                //     value - 1,
                                //     feet - 1,
                                //     10
                                // )}
                                <div
                                    key={value}
                                    className={`spinner-item ${value === feet ? 'selected opacity-1' : 'opacity-0-5'}
                                    `}
                                    onClick={() => handleFeetChange(value)}
                                    ref={(el) => (feetRefs.current[value - 1] = el)}
                                >
                                    {value}
                                </div>
                            ))}
                        </div>
                    </div>
                    <span className="height-ft">Ft</span>
                    <div className="inches position-relative">
                    <div className={'selected-inches'}></div>
                        <div className="spinner-container">
                            {Array.from({ length: 12 }, (_, index) => index + 1).map((value) => (
                                // ${getOpacityClass(
                                //     value - 1,
                                //     inches - 1,
                                //     12
                                // )}
                                <div
                                    key={value}
                                    className={`spinner-item ${value === inches ? 'selected opacity-1' : 'opacity-0-5'} `}
                                    onClick={() => handleInchesChange(value)}
                                    ref={(el) => (inchesRefs.current[value - 1] = el)}
                                >
                                    {value}
                                </div>
                            ))}
                        </div>
                    </div>
                    <span className="height-ft">In</span>
                </div>
            </div>
            <div className="questionnaire-fix-btn eligibility-fix-btn">
                <div className="divider"></div>
                <div className="footer-content">
                    <div className="skip-eligibility"></div>
                    <Button
                        btnClass={"btn-primary question-btn"}
                        btnType={"button"}
                        btnName={"Continue"}
                        onClick={handleSubmit}
                        isDisabled={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default Height;